module.exports = __webpack_public_path__ + "img/deleteicon.e4c39f50.svg";